import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"

import AppLayout from '@/layouts/app/AppSidebarLayout.vue';
    import type { BreadcrumbItemType, SharedData } from '@/types';
    import AppToaster from '@/components/AppToaster.vue';
    import { computed, type HTMLAttributes } from 'vue';
    import NoCompanyPlaceholderCard from '@/components/NoCompanyPlaceholderCard.vue';
    import { usePage } from '@inertiajs/vue3';

    interface Props {
        breadcrumbs?: BreadcrumbItemType[];
        headerClass?: HTMLAttributes['class'];
        contentClass?: HTMLAttributes['class'];
        hideHeader?: boolean;
        requireSelectedCompany?: boolean;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AppLayout',
  props: {
    breadcrumbs: { default: () => [] },
    headerClass: {},
    contentClass: {},
    hideHeader: { type: Boolean },
    requireSelectedCompany: { type: Boolean, default: false }
  },
  setup(__props: any) {

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppLayout, {
    breadcrumbs: _ctx.breadcrumbs,
    "header-class": _ctx.headerClass,
    "content-class": _ctx.contentClass,
    "hide-header": _ctx.hideHeader
  }, {
    "header-actions": _withCtx(() => [
      _renderSlot(_ctx.$slots, "header-actions")
    ]),
    default: _withCtx(() => [
      (!_ctx.requireSelectedCompany || selectedCompanyId.value)
        ? _renderSlot(_ctx.$slots, "default", { key: 0 })
        : (_openBlock(), _createBlock(NoCompanyPlaceholderCard, { key: 1 })),
      _createVNode(AppToaster)
    ]),
    _: 3
  }, 8, ["breadcrumbs", "header-class", "content-class", "hide-header"]))
}
}

})